<template>
  <div id="map" class="py-3">
    <GmapMap
      :center="{lat:42.881363, lng:-85.617624}"
      :zoom="11"
      map-type-id="roadmap"
      style="width: 500px; height: 450px"
      :options="{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        styles: styles
      }"
    >
      <GmapMarker
        :key="index"
        v-for="(group, index) in filteredMapData"
        :position="createPosition(group.address)"
        :clickable="true"
        :draggable="false"
      />
    </GmapMap>
  </div>
</template>

<script>
import mapstyle from '@/components/mapstyle.js'
export default {
  name: 'Map',
  props: {
    mapData: Array
  },
  data() {
    return {
      filteredMapData: this.mapData,
      styles: mapstyle
    }
  },
  methods: {
    createPosition(address) {
      let latlng = {
        "lat": Number(address.lat),
        "lng": Number(address.lng)
      }
      return latlng
    }
  },
  mounted() {
    this.$root.$on('filter-search-complete', (data) => {
      this.filteredMapData = data
    })
  }
}
</script>

<style>
#map {
  width: 100%
}

.vue-map-container {
  width: 100% !important;
}
</style>

